import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import cx from 'classnames';


export const Title = p => {
  let { children, className, loading, ...props } = p;
  return (
    <div className={cx("content-title", { "loading-text": loading }, className)} {...props}>
      {children}
    </div>
  );
}

export const Header = ({ split = true, className, ...props }) => (
  <div className={cx("g-content-head", { split }, className)} {...props} />
);

export const MegaHeader = ({ className, children, ...props }) => (
  <Header className={cx("mega", className)} {...props}>
    <div className="header-wrap">
      { children }
    </div>
  </Header>
);

export const HeaderLeft = ({...props}) => (<div className="header-left" {...props} />)
export const HeaderRight = ({ ...props }) => (<div className="header-right" {...props} />)

export const Breadcrumbs = p => {
  let { items, className, ...props } = p;
  return (
    <div className={cx("g-breadcrumbs", className)} {...props}>
      { _.map(items, (url, k) => <Link key={k} to={url}>{k}</Link>) }
    </div>
  );
}

export const Section = ({ align, size, className, ...props }) => (
  <div className={cx("g-section", className, align, size, )} {...props} />);
export const SectionTitle = ({ align, size, className, ...props }) => (
  <div className={cx("g-section-title", className, align, size, )} {...props} />);


export const Content = ({ align, size, className, ...props }) => (
  <div className={cx("content", className, align, size, )} {...props} />);

export const ContentCenter = ({ align,...props}) => <Content align="center" {...props} />;
export const ContentWide = ({ align,...props}) => <Content align="center" size="wide" {...props} />;
export const ContentMega = ({ className, align,...props}) => <Content align="center" className={cx("mega-header", className)} {...props} />;


export default Content;